// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ───────────────────────────────────────────── */
/* Backdrop */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* ───────────────────────────────────────────── */
/* Modal */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-modal {
  width: 941px;
  height: 602px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: "Inter", sans-serif;
}

/* ───────────────────────────────────────────── */
/* Header */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-header {
  height: 65px;
  background: #f8f9fb;
  border-bottom: 1px solid rgba(229, 229, 231, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
}

.scl--cms-components-selectMediaOverlay-title {
  font-weight: 600;
  font-size: 30px;
  color: #323539;
  margin: 0;
}

.scl--cms-components-selectMediaOverlay-close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ───────────────────────────────────────────── */
/* Body */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-body {
  flex: 1;
  padding: 22px 24px;
  overflow-y: auto;
}

.scl--cms-components-selectMediaOverlay-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

/* ───────────────────────────────────────────── */
/* Card wrapper — wraps MediaCard + selected overlay */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-card-wrapper {
  position: relative;
  border-radius: 8px;
  cursor: pointer;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition: outline 0.15s ease, transform 0.2s ease;
}

/* Selected — green border */
.scl--cms-components-selectMediaOverlay-card-wrapper--selected {
  outline: 3px solid #2eb406;
  outline-offset: 2px;
}

/* Selected green tint overlay */
.scl--cms-components-selectMediaOverlay-card-selected-overlay {
  position: absolute;
  inset: 0;
  background: rgba(153, 173, 154, 0.15);
  border-radius: 8px;
  pointer-events: none;
}

/* Hide action buttons inside MediaCard */
.scl--cms-components-selectMediaOverlay-card-wrapper
.scl--cms-components-mediaCard-actions {
  display: none;
  pointer-events: none;
  cursor: default;
}

/* ───────────────────────────────────────────── */
/* Footer */
/* ───────────────────────────────────────────── */

.scl--cms-components-selectMediaOverlay-footer {
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 24px;
  border-top: 1px solid rgba(229, 229, 231, 0.5);
  background: #ffffff;
  flex-shrink: 0;
}

.scl--cms-components-selectMediaOverlay-footer-actions {
  display: flex;
  gap: 12px;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/texteditor-fs-cp/select-media-overlay/css/selectMediaOverlay.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,aAAa;AACb,kDAAkD;;AAElD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,kDAAkD;AAClD,UAAU;AACV,kDAAkD;;AAElD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD,WAAW;AACX,kDAAkD;;AAElD;EACE,YAAY;EACZ,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD,SAAS;AACT,kDAAkD;;AAElD;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA,kDAAkD;AAClD,sDAAsD;AACtD,kDAAkD;;AAElD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,mDAAmD;AACrD;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,yCAAyC;AACzC;;EAEE,aAAa;EACb,oBAAoB;EACpB,eAAe;AACjB;;AAEA,kDAAkD;AAClD,WAAW;AACX,kDAAkD;;AAElD;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,8CAA8C;EAC9C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX","sourcesContent":["/* ───────────────────────────────────────────── */\n/* Backdrop */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n/* ───────────────────────────────────────────── */\n/* Modal */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-modal {\n  width: 941px;\n  height: 602px;\n  background: #ffffff;\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: \"Inter\", sans-serif;\n}\n\n/* ───────────────────────────────────────────── */\n/* Header */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-header {\n  height: 65px;\n  background: #f8f9fb;\n  border-bottom: 1px solid rgba(229, 229, 231, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 24px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-selectMediaOverlay-title {\n  font-weight: 600;\n  font-size: 30px;\n  color: #323539;\n  margin: 0;\n}\n\n.scl--cms-components-selectMediaOverlay-close-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ───────────────────────────────────────────── */\n/* Body */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-body {\n  flex: 1;\n  padding: 22px 24px;\n  overflow-y: auto;\n}\n\n.scl--cms-components-selectMediaOverlay-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n/* ───────────────────────────────────────────── */\n/* Card wrapper — wraps MediaCard + selected overlay */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-card-wrapper {\n  position: relative;\n  border-radius: 8px;\n  cursor: pointer;\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n  transition: outline 0.15s ease, transform 0.2s ease;\n}\n\n/* Selected — green border */\n.scl--cms-components-selectMediaOverlay-card-wrapper--selected {\n  outline: 3px solid #2eb406;\n  outline-offset: 2px;\n}\n\n/* Selected green tint overlay */\n.scl--cms-components-selectMediaOverlay-card-selected-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(153, 173, 154, 0.15);\n  border-radius: 8px;\n  pointer-events: none;\n}\n\n/* Hide action buttons inside MediaCard */\n.scl--cms-components-selectMediaOverlay-card-wrapper\n.scl--cms-components-mediaCard-actions {\n  display: none;\n  pointer-events: none;\n  cursor: default;\n}\n\n/* ───────────────────────────────────────────── */\n/* Footer */\n/* ───────────────────────────────────────────── */\n\n.scl--cms-components-selectMediaOverlay-footer {\n  height: 65px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding: 0 24px;\n  border-top: 1px solid rgba(229, 229, 231, 0.5);\n  background: #ffffff;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-selectMediaOverlay-footer-actions {\n  display: flex;\n  gap: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
